import { LassoComponent } from './Lasso.component';
import { enhance } from './Lasso.enhancers';

export const Lasso = enhance(LassoComponent);
